import { mediaPipelineQueryKeys as e } from "./useMediaPipelineQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { adminMediaPipelineApi as n } from "@maat/api-main";
//#region src/mediaPipeline/useMediaPipelineSummaryQuery.ts
var r = (r) => t({
	queryKey: e.summary(r),
	queryFn: () => n.getSummary(r)
});
//#endregion
export { r as useMediaPipelineSummaryQuery };
